export const SESSION_ID = '05bf25fa881c9d9b147af012ad5b2318645e4d48a4f2df881ffa211d8bac9a8c40';

const SESSION_ANDROID_PACKAGE = 'network.loki.messenger';
const SESSION_DOWNLOAD_URL = 'https://getsession.org/download';

export const copySessionId = async () => {
  try {
    await navigator.clipboard.writeText(SESSION_ID);
    return true;
  } catch {
    return false;
  }
};

export const openSessionApp = async () => {
  const copied = await copySessionId();
  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);

  if (isAndroid) {
    window.location.href = `intent://open/#Intent;package=${SESSION_ANDROID_PACKAGE};S.browser_fallback_url=${encodeURIComponent(SESSION_DOWNLOAD_URL)};end`;
    return copied;
  }

  if (isIOS) {
    const startedAt = Date.now();
    window.location.href = 'session://';
    window.setTimeout(() => {
      if (!document.hidden && Date.now() - startedAt < 1800) {
        window.location.href = SESSION_DOWNLOAD_URL;
      }
    }, 1200);
    return copied;
  }

  window.open(SESSION_DOWNLOAD_URL, '_blank', 'noopener,noreferrer');
  return copied;
};
